import React, { useState } from 'react'
import * as UIcons from '@iconscout/react-unicons'
import StatCard from 'components/DetailWidgets/StatCard'
import MultiLineChartCard from 'components/DetailWidgets/MultiLineChartCard'
import TabTable from '../TabTable'

const LEADERBOARD_COLUMNS = [
  { key: 'rank', label: 'Rank' },
  { key: 'user', label: 'User' },
  { key: 'predictionEntries', label: 'Prediction Entries' },
  { key: 'accuracy', label: 'Accuracy' },
  { key: 'correctPrediction', label: 'Correct Prediction' },
  { key: 'boostPointsEarned', label: 'Boost Points Earned' }
]

export default function PredictionTab({ campaign }) {
  const { prediction } = campaign
  const [chartTab, setChartTab] = useState(prediction.performance.tabs[0].key)

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {
          prediction.stats.map((stat) => (
            <StatCard key={stat.key} icon={UIcons.UilChartBar} label={stat.label} value={stat.value} trend={stat.trend} tone={stat.tone} />
          ))
        }
      </div>

      <MultiLineChartCard
        title="Prediction Performance"
        series={prediction.performance.seriesByTab[chartTab]}
        tabs={prediction.performance.tabs}
        activeTab={chartTab}
        onTabChange={setChartTab}
      />

      <div className="w-full rounded-2xl border border-border-lines p-4">
        <p className="text-base font-semibold text-dark-blue mb-3">Top Predicted Matches</p>
        <div className="w-full overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background">
                <th className="text-left font-semibold text-dark-blue px-3 py-2.5">Rank</th>
                <th className="text-left font-semibold text-dark-blue px-3 py-2.5">Match</th>
                <th className="text-left font-semibold text-dark-blue px-3 py-2.5">Prediction</th>
              </tr>
            </thead>
            <tbody>
              {
                prediction.topMatches.map((row) => (
                  <tr key={row.rank} className="border-b border-border-lines last:border-0">
                    <td className="px-3 py-2.5 text-dark-blue">{row.rank}</td>
                    <td className="px-3 py-2.5 text-dark-blue">{row.match}</td>
                    <td className="px-3 py-2.5 text-dark-blue">{row.prediction}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>

      <div>
        <p className="text-base font-semibold text-dark-blue mb-3">Top Predictors</p>
        <TabTable columns={LEADERBOARD_COLUMNS} rows={prediction.rows} searchPlaceholder="Search by name, phone, user ID" searchKeys={['user']} />
      </div>
    </div>
  )
}
